module.exports = __webpack_public_path__ + "public/1225cf4f6bcd5d6388c1a3e8b83e6f1b.ttf";